import { PercentCircleIcon } from './PercentCircleIcon';

/**
 * author: Colton Wiscombe
 * id CA4A3F7A-B20E-4937-9FD6-207B1F974DE8
 * name percent-circle
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/percent-circle.svg
 * tags
 * - Math 
 * - Shopping 
 */
export const SaleCircleIcon = PercentCircleIcon;
export default SaleCircleIcon